import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class TrackingNewsGallerySearchMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {Number} param.data.searchResultsCount
   * @param {Object} param.data.filters
   */
  map({page, culture, data}) {
    const {searchResultsCount, filters} = data

    const trackingData = {
      search_result_number: searchResultsCount
    }

    if (filters && filters.keywords) {
      trackingData.filters = filters
      trackingData.keywords = filters.keywords
    }

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
